import React from "react";

const S = {
  wrapper: { marginTop:'10px', padding:'40px', border:'3px solid grey', fontFamily:"'Georgia', serif", color:'#1a1a2e', lineHeight:'1.7' },
  h1: { fontSize:'2rem', fontWeight:'700', borderBottom:'3px solid #2E75B6', paddingBottom:'8px', marginBottom:'24px', color:'#1F3864' },
  h2: { fontSize:'1.3rem', fontWeight:'700', color:'#2E75B6', marginTop:'36px', marginBottom:'12px', borderLeft:'4px solid #2E75B6', paddingLeft:'10px' },
  p: { marginBottom:'12px', fontSize:'0.97rem' },
  infoBox: { background:'#EBF3FB', border:'2px solid #2E75B6', borderRadius:'6px', padding:'16px 20px', margin:'16px 0' },
  infoBoxTitle: { fontWeight:'700', fontFamily:"'Courier New', monospace", fontSize:'0.88rem', color:'#1F3864', marginBottom:'8px' },
  infoBoxItem: { fontSize:'0.9rem', margin:'4px 0', paddingLeft:'12px', borderLeft:'2px solid #2E75B6' },
  table: { width:'100%', borderCollapse:'collapse', marginBottom:'20px', fontSize:'0.92rem' },
  th: { background:'#2E75B6', color:'#fff', padding:'10px 14px', textAlign:'left', fontWeight:'700', fontSize:'0.9rem' },
  tdE: { padding:'10px 14px', borderBottom:'1px solid #ccd9ea', verticalAlign:'top', background:'#f5f9ff' },
  tdO: { padding:'10px 14px', borderBottom:'1px solid #ccd9ea', verticalAlign:'top', background:'#fff' },
  tdL: { fontWeight:'600', color:'#1F3864', whiteSpace:'nowrap', width:'220px' },
  code: { fontFamily:"'Courier New', monospace", fontSize:'0.88rem', whiteSpace:'pre-wrap' },
  dWrap: { margin:'24px 0', background:'#f8fbff', border:'1px solid #ccd9ea', borderRadius:'8px', padding:'20px' },
  dTitle: { fontWeight:'700', fontSize:'0.95rem', color:'#1F3864', marginBottom:'12px', textAlign:'center', letterSpacing:'0.02em' },
  dCaption: { fontSize:'0.84rem', color:'#555', textAlign:'center', marginTop:'10px', fontStyle:'italic' },
};

function InfoBox({ title, items }) {
  return (
    <div style={S.infoBox}>
      <div style={S.infoBoxTitle}>{title}</div>
      {items.map((item, i) => <div key={i} style={S.infoBoxItem}>{item}</div>)}
    </div>
  );
}

function Table2({ rows }) {
  return (
    <table style={S.table}>
      <thead><tr>
        <th style={{ ...S.th, width:'220px' }}>Concept</th>
        <th style={S.th}>Formula / Notes</th>
      </tr></thead>
      <tbody>
        {rows.map(([label, content], i) => (
          <tr key={i}>
            <td style={{ ...(i%2===0?S.tdE:S.tdO), ...S.tdL }}>{label}</td>
            <td style={{ ...(i%2===0?S.tdE:S.tdO), ...S.code }}>{content}</td>
          </tr>
        ))}
      </tbody>
    </table>
  );
}

function DiagramCartesian() {
  const W=900, H=360;
  const ox=200, oy=200, sc=52;
  const tx = x => ox + x*sc;
  const ty = y => oy - y*sc;
  const ax=1, ay=3, bx=4, by=1;
  const mx=(ax+bx)/2, my=(ay+by)/2;
  const dist = Math.sqrt((bx-ax)**2+(by-ay)**2).toFixed(2);
  const px0=490, panW=W-px0-12;
  const gridVals = [-3,-2,-1,0,1,2,3,4];
  return (
    <div style={S.dWrap}>
      <div style={S.dTitle}>The Cartesian Plane — Points, Distance, Midpoint, and Quadrants</div>
      <svg viewBox={`0 0 ${W} ${H}`} style={{width:'100%',display:'block'}}>
        {gridVals.map(v=>(
          <g key={v}>
            <line x1={tx(v)} y1={ty(-3)} x2={tx(v)} y2={ty(3.5)} stroke="#eee" strokeWidth="1"/>
            <line x1={tx(-3.5)} y1={ty(v)} x2={tx(4.2)} y2={ty(v)} stroke="#eee" strokeWidth="1"/>
          </g>
        ))}
        <line x1={tx(-3.5)} y1={oy} x2={tx(4.2)} y2={oy} stroke="#1F3864" strokeWidth="1.6"/>
        <line x1={ox} y1={ty(3.5)} x2={ox} y2={ty(-3)} stroke="#1F3864" strokeWidth="1.6"/>
        <polygon points={`${tx(4.2)},${oy} ${tx(4.2)-8},${oy-4} ${tx(4.2)-8},${oy+4}`} fill="#1F3864"/>
        <polygon points={`${ox},${ty(3.5)} ${ox-4},${ty(3.5)+8} ${ox+4},${ty(3.5)+8}`} fill="#1F3864"/>
        <text x={tx(4.2)+6} y={oy+4} fontSize="16" fill="#1F3864" fontWeight="700">x</text>
        <text x={ox+5} y={ty(3.5)-4} fontSize="16" fill="#1F3864" fontWeight="700">y</text>
        {[-3,-2,-1,1,2,3,4].map(v=>(
          <text key={v} x={tx(v)} y={oy+16} textAnchor="middle" fontSize="12" fill="#bbb">{v}</text>
        ))}
        {[-2,-1,1,2,3].map(v=>(
          <text key={v} x={ox-6} y={ty(v)+4} textAnchor="end" fontSize="12" fill="#bbb">{v}</text>
        ))}
        <text x={tx(2.5)} y={ty(2.8)} textAnchor="middle" fontSize="13" fill="#dde8f5" fontWeight="700">I (+,+)</text>
        <text x={tx(-1.8)} y={ty(2.8)} textAnchor="middle" fontSize="13" fill="#dde8f5" fontWeight="700">II (−,+)</text>
        <text x={tx(-1.8)} y={ty(-2)} textAnchor="middle" fontSize="13" fill="#dde8f5" fontWeight="700">III (−,−)</text>
        <text x={tx(2.5)} y={ty(-2)} textAnchor="middle" fontSize="13" fill="#dde8f5" fontWeight="700">IV (+,−)</text>
        <line x1={tx(ax)} y1={ty(ay)} x2={tx(bx)} y2={ty(by)} stroke="#9b59b6" strokeWidth="2" strokeDasharray="6,3"/>
        <line x1={tx(ax)} y1={ty(ay)} x2={tx(bx)} y2={ty(ay)} stroke="#2E75B6" strokeWidth="1.5" strokeDasharray="4,3"/>
        <line x1={tx(bx)} y1={ty(ay)} x2={tx(bx)} y2={ty(by)} stroke="#c0392b" strokeWidth="1.5" strokeDasharray="4,3"/>
        <text x={tx((ax+bx)/2)} y={ty(ay)+18} textAnchor="middle" fontSize="12" fill="#2E75B6" fontWeight="700">Δx=3</text>
        <text x={tx(bx)+14} y={ty((ay+by)/2)} fontSize="12" fill="#c0392b" fontWeight="700">Δy=−2</text>
        <circle cx={tx(ax)} cy={ty(ay)} r={6} fill="#2E75B6" stroke="#fff" strokeWidth="2"/>
        <text x={tx(ax)-10} y={ty(ay)-10} fontSize="14" fill="#2E75B6" fontWeight="700">A(1,3)</text>
        <circle cx={tx(bx)} cy={ty(by)} r={6} fill="#c0392b" stroke="#fff" strokeWidth="2"/>
        <text x={tx(bx)+8} y={ty(by)-10} fontSize="14" fill="#c0392b" fontWeight="700">B(4,1)</text>
        <circle cx={tx(mx)} cy={ty(my)} r={5} fill="#27ae60" stroke="#fff" strokeWidth="2"/>
        <text x={tx(mx)+10} y={ty(my)-8} fontSize="13" fill="#27ae60" fontWeight="700">M(2.5,2)</text>
        <text x={tx((ax+bx)/2)-38} y={ty((ay+by)/2)-14} fontSize="12" fill="#9b59b6" fontWeight="700">d≈{dist}</text>
        <rect x={px0} y={10} width={panW} height={H-20} rx={5} fill="#fff" stroke="#ccd9ea"/>
        <text x={px0+panW/2} y={30} textAnchor="middle" fontSize="15" fill="#1F3864" fontWeight="700">Key Formulas</text>
        {[
          {y:38, bg:"#EBF3FB", bc:"#2E75B6", title:"Distance Formula", lines:["d = √((x₂-x₁)² + (y₂-y₁)²)","= √(9+4) = √13 ≈ 3.61"]},
          {y:112, bg:"#f0fff4", bc:"#27ae60", title:"Midpoint Formula", lines:["M = ((x₁+x₂)/2, (y₁+y₂)/2)","= (2.5,  2)"]},
          {y:186, bg:"#fff7ee", bc:"#e07b00", title:"Section Formula (m:n)", lines:["P = ((mx₂+nx₁)/(m+n),","     (my₂+ny₁)/(m+n))"]},
          {y:260, bg:"#f5d0ff", bc:"#9b59b6", title:"Quadrants", lines:["I: x>0,y>0   II: x<0,y>0","III: x<0,y<0  IV: x>0,y<0"]},
        ].map(({y,bg,bc,title,lines})=>(
          <g key={title}>
            <rect x={px0+6} y={y} width={panW-12} height={68} rx={3} fill={bg} stroke={bc} strokeWidth="1"/>
            <text x={px0+12} y={y+15} fontSize="12" fill="#1F3864" fontWeight="700">{title}</text>
            {lines.map((ln,i)=><text key={i} x={px0+12} y={y+30+i*16} fontSize="11" fill="#444" fontFamily="'Courier New',monospace">{ln}</text>)}
          </g>
        ))}
      </svg>
      <div style={S.dCaption}>The Cartesian plane is defined by two perpendicular number lines. Points are ordered pairs (x,y). Distance uses the Pythagorean theorem on Δx and Δy; midpoint averages each coordinate.</div>
    </div>
  );
}

function DiagramLines() {
  const W=900, H=350;
  const PW = W/3 - 8;

  // Panel 1: slope-intercept
  const ox1=14+PW/2-20, oy1=210, sc1=44;
  const tx1 = x => ox1+x*sc1;
  const ty1 = y => oy1-y*sc1;
  const m1=0.75, c1=1;

  // Panel 2: parallel & perp
  const ox2=14+PW+8+PW/2-20, oy2=210, sc2=44;
  const tx2 = x => ox2+x*sc2;
  const ty2 = y => oy2-y*sc2;

  // Panel 3: angle
  const ox3=14+2*(PW+8)+PW/2-20, oy3=210, sc3=44;
  const tx3 = x => ox3+x*sc3;
  const ty3 = y => oy3-y*sc3;

  // Perp intersection point (m1=1, m2=-1, line1: y=x+1, line2: y=-x+1.5 => x=0.25, y=1.25)
  const ix = tx2(0.25), iy = ty2(1.25);

  return (
    <div style={S.dWrap}>
      <div style={S.dTitle}>Straight Lines — Slope, Forms, Parallel, Perpendicular, and Angle Between Lines</div>
      <svg viewBox={`0 0 ${W} ${H}`} style={{width:'100%',display:'block'}}>
        {/* Panel 1 */}
        <rect x={14} y={10} width={PW} height={H-20} rx={5} fill="#fff" stroke="#ccd9ea"/>
        <text x={14+PW/2} y={28} textAnchor="middle" fontSize="15" fill="#1F3864" fontWeight="700">Slope-Intercept Form</text>
        <line x1={tx1(-1.5)} y1={oy1} x2={tx1(3.8)} y2={oy1} stroke="#1F3864" strokeWidth="1.2"/>
        <line x1={ox1} y1={ty1(3.5)} x2={ox1} y2={ty1(-1.5)} stroke="#1F3864" strokeWidth="1.2"/>
        {[-1,0,1,2,3].map(v=>(
          <g key={v}>
            <line x1={tx1(v)} y1={oy1-3} x2={tx1(v)} y2={oy1+3} stroke="#bbb" strokeWidth="1"/>
            <line x1={ox1-3} y1={ty1(v)} x2={ox1+3} y2={ty1(v)} stroke="#bbb" strokeWidth="1"/>
          </g>
        ))}
        <line x1={tx1(-1.3)} y1={ty1(m1*-1.3+c1)} x2={tx1(3.2)} y2={ty1(m1*3.2+c1)} stroke="#2E75B6" strokeWidth="2.5"/>
        <circle cx={tx1(0)} cy={ty1(c1)} r={5} fill="#27ae60" stroke="#fff" strokeWidth="1.5"/>
        <text x={tx1(0)+8} y={ty1(c1)-6} fontSize="12" fill="#27ae60" fontWeight="700">c=1</text>
        <line x1={tx1(1)} y1={ty1(m1+c1)} x2={tx1(2)} y2={ty1(m1+c1)} stroke="#e07b00" strokeWidth="1.5"/>
        <line x1={tx1(2)} y1={ty1(m1+c1)} x2={tx1(2)} y2={ty1(2*m1+c1)} stroke="#e07b00" strokeWidth="1.5"/>
        <text x={tx1(1.5)} y={ty1(m1+c1)+16} textAnchor="middle" fontSize="11" fill="#e07b00" fontWeight="700">run=1</text>
        <text x={tx1(2)+12} y={ty1(1.5*m1+c1)} fontSize="11" fill="#e07b00" fontWeight="700">rise</text>
        <text x={14+PW/2} y={285} textAnchor="middle" fontSize="13" fill="#2E75B6" fontFamily="'Courier New',monospace" fontWeight="700">y = mx + c</text>
        <text x={14+PW/2} y={302} textAnchor="middle" fontSize="12" fill="#555" fontFamily="'Courier New',monospace">m = slope = rise/run</text>
        <text x={14+PW/2} y={317} textAnchor="middle" fontSize="12" fill="#27ae60" fontFamily="'Courier New',monospace">c = y-intercept</text>
        <rect x={22} y={328} width={PW-16} height={14} rx={2} fill="#EBF3FB"/>
        <text x={14+PW/2} y={339} textAnchor="middle" fontSize="11" fill="#1F3864">m = (y₂−y₁)/(x₂−x₁)</text>

        {/* Panel 2 */}
        <rect x={14+PW+8} y={10} width={PW} height={H-20} rx={5} fill="#fff" stroke="#ccd9ea"/>
        <text x={14+PW+8+PW/2} y={28} textAnchor="middle" fontSize="15" fill="#1F3864" fontWeight="700">Parallel &amp; Perpendicular</text>
        <line x1={tx2(-1.2)} y1={oy2} x2={tx2(3.6)} y2={oy2} stroke="#1F3864" strokeWidth="1.2"/>
        <line x1={ox2} y1={ty2(3.5)} x2={ox2} y2={ty2(-1.5)} stroke="#1F3864" strokeWidth="1.2"/>
        <line x1={tx2(-1)} y1={ty2(0)} x2={tx2(2.8)} y2={ty2(3.8)} stroke="#2E75B6" strokeWidth="2.5"/>
        <text x={tx2(2.8)+5} y={ty2(3.8)} fontSize="12" fill="#2E75B6" fontWeight="700">L₁</text>
        <line x1={tx2(-1)} y1={ty2(-0.8)} x2={tx2(2.4)} y2={ty2(3)} stroke="#2E75B6" strokeWidth="2.5" strokeDasharray="6,3"/>
        <text x={tx2(2.4)+5} y={ty2(3)} fontSize="12" fill="#2E75B6" fontWeight="700">L₂</text>
        <text x={14+PW+8+20} y={ty2(3.4)} fontSize="11" fill="#2E75B6">∥ same slope m</text>
        <line x1={tx2(-1)} y1={ty2(1.25+1)} x2={tx2(2.5)} y2={ty2(1.25-2.5)} stroke="#c0392b" strokeWidth="2.5"/>
        <text x={tx2(2.5)+5} y={ty2(1.25-2.5)} fontSize="12" fill="#c0392b" fontWeight="700">L₃</text>
        <polyline points={`${ix-10},${iy-10} ${ix},${iy-10} ${ix},${iy}`} fill="none" stroke="#888" strokeWidth="1.2"/>
        <rect x={14+PW+8+10} y={262} width={PW-20} height={76} rx={3} fill="#EBF3FB" stroke="#2E75B6" strokeWidth="1"/>
        <text x={14+PW+8+16} y={278} fontSize="13" fill="#1F3864" fontWeight="700">Parallel: m₁ = m₂</text>
        <text x={14+PW+8+16} y={294} fontSize="12" fill="#555" fontFamily="'Courier New',monospace">same slope, diff intercept</text>
        <text x={14+PW+8+16} y={314} fontSize="13" fill="#1F3864" fontWeight="700">Perpendicular: m₁×m₂=−1</text>
        <text x={14+PW+8+16} y={330} fontSize="12" fill="#555" fontFamily="'Courier New',monospace">negative reciprocal slopes</text>

        {/* Panel 3 */}
        <rect x={14+2*(PW+8)} y={10} width={PW} height={H-20} rx={5} fill="#fff" stroke="#ccd9ea"/>
        <text x={14+2*(PW+8)+PW/2} y={28} textAnchor="middle" fontSize="15" fill="#1F3864" fontWeight="700">Angle Between Lines</text>
        <line x1={tx3(-1.2)} y1={oy3} x2={tx3(3.6)} y2={oy3} stroke="#1F3864" strokeWidth="1.2"/>
        <line x1={ox3} y1={ty3(3.5)} x2={ox3} y2={ty3(-1.5)} stroke="#1F3864" strokeWidth="1.2"/>
        <line x1={tx3(-1)} y1={ty3(-0.5+0.5)} x2={tx3(3.2)} y2={ty3(1.6+0.5)} stroke="#2E75B6" strokeWidth="2.5"/>
        <text x={tx3(3.2)+5} y={ty3(2.1)} fontSize="12" fill="#2E75B6" fontWeight="700">m₁=0.5</text>
        <line x1={tx3(-0.2)} y1={ty3(-0.5+0.5)} x2={tx3(1.3)} y2={ty3(3.25+0.5)} stroke="#c0392b" strokeWidth="2.5"/>
        <text x={tx3(1.3)+5} y={ty3(3.75+0.5-0.5)} fontSize="12" fill="#c0392b" fontWeight="700">m₂=2.5</text>
        <path d={`M ${tx3(0.9)},${ty3(0.95)} A 36 36 0 0 0 ${tx3(0.38)},${ty3(1.45)}`} fill="none" stroke="#9b59b6" strokeWidth="2"/>
        <text x={tx3(1.0)} y={ty3(1.35)} fontSize="13" fill="#9b59b6" fontWeight="700">θ</text>
        <rect x={14+2*(PW+8)+10} y={254} width={PW-20} height={84} rx={3} fill="#EBF3FB" stroke="#9b59b6" strokeWidth="1"/>
        <text x={14+2*(PW+8)+16} y={270} fontSize="13" fill="#1F3864" fontWeight="700">Angle between two lines:</text>
        <text x={14+2*(PW+8)+16} y={287} fontSize="12" fill="#9b59b6" fontFamily="'Courier New',monospace">tan θ=|(m₁−m₂)/(1+m₁m₂)|</text>
        <text x={14+2*(PW+8)+16} y={306} fontSize="12" fill="#555">θ=0°: parallel (m₁=m₂)</text>
        <text x={14+2*(PW+8)+16} y={322} fontSize="12" fill="#555">θ=90°: perpendicular</text>
        <text x={14+2*(PW+8)+16} y={333} fontSize="11" fill="#888" fontFamily="'Courier New',monospace">(1+m₁m₂=0)</text>
      </svg>
      <div style={S.dCaption}>The slope m=rise/run defines steepness and direction. Parallel lines share the same slope; perpendicular lines have slopes whose product is −1. The angle between two lines follows from the tangent subtraction formula.</div>
    </div>
  );
}

function DiagramCircle() {
  const W=900, H=350;
  const cx1=160, cy1=175, r1=110;
  const cx2=441, cy2=175, r2=90;
  const ex=cx2+195, ey=cy2;
  const dx=ex-cx2, dy=ey-cy2, dist2=Math.sqrt(dx*dx+dy*dy);
  const ang=Math.acos(r2/dist2);
  const base=Math.atan2(dy,dx)+Math.PI;
  const t1x=cx2+r2*Math.cos(base+ang), t1y=cy2+r2*Math.sin(base+ang);
  const t2x=cx2+r2*Math.cos(base-ang), t2y=cy2+r2*Math.sin(base-ang);
  const cx3=760, cy3=175, r3=95;
  const sa1=-0.6, sa2=1.2;
  const sx1=cx3+r3*Math.cos(sa1), sy1=cy3-r3*Math.sin(sa1);
  const sx2=cx3+r3*Math.cos(sa2), sy2=cy3-r3*Math.sin(sa2);
  const chA1=Math.PI*0.2, chA2=Math.PI*0.85;
  const arcA1=-0.4, arcA2=0.9;
  return (
    <div style={S.dWrap}>
      <div style={S.dTitle}>Circle — Standard Form, Tangent Lines, Chords, and Arc Length</div>
      <svg viewBox={`0 0 ${W} ${H}`} style={{width:'100%',display:'block'}}>
        {/* Panel 1: anatomy */}
        <rect x={10} y={10} width={282} height={H-20} rx={5} fill="#fff" stroke="#ccd9ea"/>
        <text x={151} y={28} textAnchor="middle" fontSize="15" fill="#1F3864" fontWeight="700">Circle Anatomy</text>
        <circle cx={cx1} cy={cy1} r={r1} fill="#d0e8ff" fillOpacity="0.4" stroke="#2E75B6" strokeWidth="2"/>
        <circle cx={cx1} cy={cy1} r={4} fill="#1F3864"/>
        <text x={cx1+7} y={cy1+4} fontSize="12" fill="#1F3864" fontWeight="700">(h,k)</text>
        <line x1={cx1} y1={cy1} x2={cx1+r1*0.707} y2={cy1-r1*0.707} stroke="#c0392b" strokeWidth="2"/>
        <text x={cx1+r1*0.37} y={cy1-r1*0.37-6} fontSize="13" fill="#c0392b" fontWeight="700">r</text>
        <line x1={cx1-r1} y1={cy1} x2={cx1+r1} y2={cy1} stroke="#27ae60" strokeWidth="1.5" strokeDasharray="5,3"/>
        <text x={cx1} y={cy1+16} textAnchor="middle" fontSize="11" fill="#27ae60" fontWeight="700">diameter = 2r</text>
        <line x1={cx1+r1*Math.cos(chA1)} y1={cy1-r1*Math.sin(chA1)} x2={cx1+r1*Math.cos(chA2)} y2={cy1-r1*Math.sin(chA2)} stroke="#9b59b6" strokeWidth="1.8"/>
        <text x={cx1-88} y={cy1-60} fontSize="11" fill="#9b59b6" fontWeight="700">chord</text>
        <path d={`M ${cx1+r1*Math.cos(arcA1)},${cy1-r1*Math.sin(arcA1)} A ${r1} ${r1} 0 0 0 ${cx1+r1*Math.cos(arcA2)},${cy1-r1*Math.sin(arcA2)}`} fill="none" stroke="#e07b00" strokeWidth="3"/>
        <text x={cx1+r1+8} y={cy1-20} fontSize="11" fill="#e07b00" fontWeight="700">arc</text>
        <rect x={16} y={290} width={270} height={46} rx={3} fill="#EBF3FB" stroke="#2E75B6" strokeWidth="1"/>
        <text x={22} y={306} fontSize="12" fill="#1F3864" fontWeight="700">Standard form:</text>
        <text x={22} y={322} fontSize="12" fill="#2E75B6" fontFamily="'Courier New',monospace">(x−h)²+(y−k)²=r²</text>

        {/* Panel 2: tangent */}
        <rect x={300} y={10} width={282} height={H-20} rx={5} fill="#fff" stroke="#ccd9ea"/>
        <text x={441} y={28} textAnchor="middle" fontSize="15" fill="#1F3864" fontWeight="700">Tangent from External Point</text>
        <circle cx={cx2} cy={cy2} r={r2} fill="#d0e8ff" fillOpacity="0.4" stroke="#2E75B6" strokeWidth="2"/>
        <circle cx={cx2} cy={cy2} r={4} fill="#1F3864"/>
        <text x={cx2+6} y={cy2+4} fontSize="11" fill="#1F3864" fontWeight="700">C</text>
        <circle cx={ex} cy={ey} r={5} fill="#e07b00" stroke="#fff" strokeWidth="1.5"/>
        <text x={ex+8} y={ey+4} fontSize="12" fill="#e07b00" fontWeight="700">P</text>
        <line x1={ex} y1={ey} x2={t1x} y2={t1y} stroke="#c0392b" strokeWidth="2"/>
        <line x1={ex} y1={ey} x2={t2x} y2={t2y} stroke="#c0392b" strokeWidth="2"/>
        <circle cx={t1x} cy={t1y} r={4} fill="#c0392b"/>
        <circle cx={t2x} cy={t2y} r={4} fill="#c0392b"/>
        <line x1={cx2} y1={cy2} x2={t1x} y2={t1y} stroke="#9b59b6" strokeWidth="1.4" strokeDasharray="4,3"/>
        <line x1={cx2} y1={cy2} x2={ex} y2={ey} stroke="#27ae60" strokeWidth="1.4" strokeDasharray="4,3"/>
        <text x={(cx2+ex)/2} y={cy2-12} textAnchor="middle" fontSize="11" fill="#27ae60" fontWeight="700">d</text>
        <rect x={306} y={290} width={270} height={46} rx={3} fill="#EBF3FB" stroke="#2E75B6" strokeWidth="1"/>
        <text x={312} y={306} fontSize="12" fill="#1F3864" fontWeight="700">Tangent length from P:</text>
        <text x={312} y={322} fontSize="12" fill="#c0392b" fontFamily="'Courier New',monospace">L = √(d² − r²)</text>

        {/* Panel 3: chord arc sector */}
        <rect x={590} y={10} width={300} height={H-20} rx={5} fill="#fff" stroke="#ccd9ea"/>
        <text x={740} y={28} textAnchor="middle" fontSize="15" fill="#1F3864" fontWeight="700">Chord, Arc &amp; Sector</text>
        <circle cx={cx3} cy={cy3} r={r3} fill="#d0e8ff" fillOpacity="0.4" stroke="#2E75B6" strokeWidth="2"/>
        <circle cx={cx3} cy={cy3} r={4} fill="#1F3864"/>
        <path d={`M ${cx3},${cy3} L ${sx1},${sy1} A ${r3} ${r3} 0 0 0 ${sx2},${sy2} Z`} fill="#d0e8ff" fillOpacity="0.7" stroke="#2E75B6" strokeWidth="1.5"/>
        <path d={`M ${sx1},${sy1} A ${r3} ${r3} 0 0 0 ${sx2},${sy2}`} fill="none" stroke="#e07b00" strokeWidth="3"/>
        <text x={cx3+r3+8} y={cy3-30} fontSize="11" fill="#e07b00" fontWeight="700">arc = rθ</text>
        <line x1={sx1} y1={sy1} x2={sx2} y2={sy2} stroke="#9b59b6" strokeWidth="2"/>
        <text x={(sx1+sx2)/2+6} y={(sy1+sy2)/2-8} fontSize="11" fill="#9b59b6" fontWeight="700">chord</text>
        <path d={`M ${cx3+30*Math.cos(sa1)},${cy3-30*Math.sin(sa1)} A 30 30 0 0 0 ${cx3+30*Math.cos(sa2)},${cy3-30*Math.sin(sa2)}`} fill="none" stroke="#c0392b" strokeWidth="1.8"/>
        <text x={cx3+36} y={cy3-8} fontSize="13" fill="#c0392b" fontWeight="700">θ</text>
        <rect x={596} y={268} width={287} height={72} rx={3} fill="#EBF3FB" stroke="#2E75B6" strokeWidth="1"/>
        <text x={602} y={284} fontSize="12" fill="#1F3864" fontWeight="700">Arc length:  s = rθ  (θ in radians)</text>
        <text x={602} y={300} fontSize="12" fill="#2E75B6" fontFamily="'Courier New',monospace">Sector area = ½r²θ</text>
        <text x={602} y={316} fontSize="12" fill="#9b59b6" fontFamily="'Courier New',monospace">Chord = 2r sin(θ/2)</text>
        <text x={602} y={332} fontSize="12" fill="#555">Circumference=2πr,  Area=πr²</text>
      </svg>
      <div style={S.dCaption}>A circle is all points equidistant from a centre. A tangent from an external point forms a right angle with the radius at the point of contact. Arc length and sector area scale linearly with θ in radians.</div>
    </div>
  );
}

function DiagramConics() {
  const W=900, H=340;
  const PW = W/4 - 8;

  // Parabola points
  const parOx=14+PW/2, parOy=190, parSc=34;
  const parPts=[];
  for(let x=-2.5;x<=2.5;x+=0.1) parPts.push(`${parOx+x*parSc},${parOy-(x*x)*parSc*0.6}`);

  // Ellipse
  const elOx=14+PW+8+PW/2, elOy=175, elA=PW/2-18, elB=elA*0.6;
  const elC=Math.sqrt(elA*elA-elB*elB);

  // Hyperbola
  const hyOx=14+2*(PW+8)+PW/2, hyOy=175, hyA=55, hyB=45;
  const hyC=Math.sqrt(hyA*hyA+hyB*hyB);
  const hyPts1=[], hyPts2=[];
  for(let t=-3.2;t<=3.2;t+=0.08){
    const x=hyA*Math.cosh(t);
    hyPts1.push(`${hyOx+x},${hyOy+hyB*t}`);
    hyPts2.push(`${hyOx-x},${hyOy+hyB*t}`);
  }

  // Eccentricity panel
  const ecX=14+3*(PW+8), ecW=W-ecX-14;

  return (
    <div style={S.dWrap}>
      <div style={S.dTitle}>Conic Sections — Parabola, Ellipse, Hyperbola, and Their Standard Forms</div>
      <svg viewBox={`0 0 ${W} ${H}`} style={{width:'100%',display:'block'}}>
        {/* Parabola */}
        <rect x={14} y={10} width={PW} height={H-20} rx={5} fill="#fff" stroke="#ccd9ea"/>
        <text x={14+PW/2} y={28} textAnchor="middle" fontSize="15" fill="#1F3864" fontWeight="700">Parabola</text>
        <line x1={14+8} y1={parOy} x2={14+PW-8} y2={parOy} stroke="#ddd" strokeWidth="1"/>
        <line x1={parOx} y1={parOy+50} x2={parOx} y2={parOy-140} stroke="#ddd" strokeWidth="1"/>
        <polyline points={parPts.join(" ")} fill="none" stroke="#2E75B6" strokeWidth="2.5"/>
        <circle cx={parOx} cy={parOy} r={4} fill="#c0392b"/>
        <text x={parOx+6} y={parOy+14} fontSize="11" fill="#c0392b" fontWeight="700">V(h,k)</text>
        <circle cx={parOx} cy={parOy-parSc*0.24} r={4} fill="#e07b00"/>
        <text x={parOx+6} y={parOy-parSc*0.24+4} fontSize="11" fill="#e07b00" fontWeight="700">F</text>
        <line x1={14+10} y1={parOy+parSc*0.24} x2={14+PW-10} y2={parOy+parSc*0.24} stroke="#27ae60" strokeWidth="1.5" strokeDasharray="5,3"/>
        <text x={14+PW-10} y={parOy+parSc*0.24-4} textAnchor="end" fontSize="10" fill="#27ae60" fontWeight="700">directrix</text>
        <rect x={20} y={262} width={PW-12} height={60} rx={3} fill="#EBF3FB" stroke="#2E75B6" strokeWidth="1"/>
        <text x={26} y={278} fontSize="12" fill="#1F3864" fontWeight="700">Opens up/down:</text>
        <text x={26} y={294} fontSize="11" fill="#2E75B6" fontFamily="'Courier New',monospace">(x−h)²=4p(y−k)</text>
        <text x={26} y={310} fontSize="11" fill="#555">p = focal distance</text>

        {/* Ellipse */}
        <rect x={14+PW+8} y={10} width={PW} height={H-20} rx={5} fill="#fff" stroke="#ccd9ea"/>
        <text x={elOx} y={28} textAnchor="middle" fontSize="15" fill="#1F3864" fontWeight="700">Ellipse</text>
        <ellipse cx={elOx} cy={elOy} rx={elA} ry={elB} fill="#d0e8ff" fillOpacity="0.4" stroke="#27ae60" strokeWidth="2.2"/>
        <line x1={elOx-elA} y1={elOy} x2={elOx+elA} y2={elOy} stroke="#27ae60" strokeWidth="1.2" strokeDasharray="4,3"/>
        <line x1={elOx} y1={elOy-elB} x2={elOx} y2={elOy+elB} stroke="#27ae60" strokeWidth="1.2" strokeDasharray="4,3"/>
        <circle cx={elOx} cy={elOy} r={4} fill="#1F3864"/>
        <text x={elOx+elA/2} y={elOy+14} textAnchor="middle" fontSize="12" fill="#27ae60" fontWeight="700">a</text>
        <text x={elOx+8} y={elOy-elB/2} fontSize="12" fill="#c0392b" fontWeight="700">b</text>
        <circle cx={elOx-elC} cy={elOy} r={4} fill="#e07b00"/>
        <circle cx={elOx+elC} cy={elOy} r={4} fill="#e07b00"/>
        <text x={elOx} y={elOy-elB-10} textAnchor="middle" fontSize="10" fill="#e07b00">F₁  F₂ (foci)</text>
        <rect x={14+PW+14} y={262} width={PW-12} height={60} rx={3} fill="#f0fff4" stroke="#27ae60" strokeWidth="1"/>
        <text x={14+PW+20} y={278} fontSize="12" fill="#1F3864" fontWeight="700">Standard form (a&gt;b):</text>
        <text x={14+PW+20} y={294} fontSize="11" fill="#27ae60" fontFamily="'Courier New',monospace">x²/a²+y²/b²=1</text>
        <text x={14+PW+20} y={310} fontSize="11" fill="#555">c²=a²−b², e=c/a&lt;1</text>

        {/* Hyperbola */}
        <rect x={14+2*(PW+8)} y={10} width={PW} height={H-20} rx={5} fill="#fff" stroke="#ccd9ea"/>
        <text x={hyOx} y={28} textAnchor="middle" fontSize="15" fill="#1F3864" fontWeight="700">Hyperbola</text>
        <line x1={hyOx-PW/2+10} y1={hyOy-(hyB/hyA)*(PW/2-10)} x2={hyOx+PW/2-10} y2={hyOy+(hyB/hyA)*(PW/2-10)} stroke="#ddd" strokeWidth="1.2" strokeDasharray="4,3"/>
        <line x1={hyOx-PW/2+10} y1={hyOy+(hyB/hyA)*(PW/2-10)} x2={hyOx+PW/2-10} y2={hyOy-(hyB/hyA)*(PW/2-10)} stroke="#ddd" strokeWidth="1.2" strokeDasharray="4,3"/>
        <polyline points={hyPts1.join(" ")} fill="none" stroke="#c0392b" strokeWidth="2.2"/>
        <polyline points={hyPts2.join(" ")} fill="none" stroke="#c0392b" strokeWidth="2.2"/>
        <circle cx={hyOx} cy={hyOy} r={3} fill="#1F3864"/>
        <circle cx={hyOx+hyC} cy={hyOy} r={4} fill="#e07b00"/>
        <circle cx={hyOx-hyC} cy={hyOy} r={4} fill="#e07b00"/>
        <text x={hyOx} y={hyOy+14} textAnchor="middle" fontSize="10" fill="#e07b00">foci</text>
        <text x={hyOx+PW/2-14} y={hyOy-(hyB/hyA)*(PW/2-20)-6} fontSize="9" fill="#888">asymptotes</text>
        <rect x={14+2*(PW+8)+6} y={262} width={PW-12} height={60} rx={3} fill="#fff7ee" stroke="#c0392b" strokeWidth="1"/>
        <text x={14+2*(PW+8)+12} y={278} fontSize="12" fill="#1F3864" fontWeight="700">Standard form:</text>
        <text x={14+2*(PW+8)+12} y={294} fontSize="11" fill="#c0392b" fontFamily="'Courier New',monospace">x²/a²−y²/b²=1</text>
        <text x={14+2*(PW+8)+12} y={310} fontSize="11" fill="#555">c²=a²+b², e=c/a&gt;1</text>

        {/* Eccentricity */}
        <rect x={ecX} y={10} width={ecW} height={H-20} rx={5} fill="#fff" stroke="#ccd9ea"/>
        <text x={ecX+ecW/2} y={28} textAnchor="middle" fontSize="15" fill="#1F3864" fontWeight="700">Eccentricity e</text>
        {[
          {label:"Circle", e:"e = 0", desc:"perfect symmetry", color:"#2E75B6", y:46},
          {label:"Ellipse", e:"0 < e < 1", desc:"elongated circle", color:"#27ae60", y:108},
          {label:"Parabola", e:"e = 1", desc:"open curve", color:"#e07b00", y:170},
          {label:"Hyperbola", e:"e > 1", desc:"two branches", color:"#c0392b", y:232},
        ].map(({label,e,desc,color,y})=>(
          <g key={label}>
            <rect x={ecX+8} y={y} width={ecW-16} height={56} rx={4} fill="#f8fbff" stroke={color} strokeWidth="1.5"/>
            <text x={ecX+16} y={y+18} fontSize="14" fill={color} fontWeight="700">{label}</text>
            <text x={ecX+16} y={y+35} fontSize="13" fill="#1F3864" fontFamily="'Courier New',monospace" fontWeight="700">{e}</text>
            <text x={ecX+16} y={y+50} fontSize="11" fill="#666">{desc}</text>
          </g>
        ))}
      </svg>
      <div style={S.dCaption}>All conics arise from slicing a double cone. Eccentricity e unifies them: e=0 circle, e&lt;1 ellipse, e=1 parabola, e&gt;1 hyperbola. The focus-directrix definition states that the ratio of distance to focus over distance to directrix equals e.</div>
    </div>
  );
}

function DiagramTransformations() {
  const W=900, H=310;
  const PW=(W-5*8)/4;
  const sc=36;
  const orig=[[0,0],[2,0],[1,2]];
  const toSVG=(pts,ox,oy)=>pts.map(([x,y])=>[ox+x*sc, oy-y*sc]);

  // Panel origins
  const ox1=14+PW/2-sc, oy1=195;
  const ox2=14+PW+8+PW/2-sc*0.5, oy2=195;
  const ox3=14+2*(PW+8)+PW/2, oy3=190;
  const ox4=14+3*(PW+8)+PW/2-sc, oy4=210;

  const origPts1=toSVG(orig,ox1,oy1);
  const transPts=toSVG([[2,1],[4,1],[3,3]],ox1,oy1);

  const origPts2=toSVG(orig,ox2,oy2);
  const reflPts=toSVG([[0,0],[-2,0],[-1,2]],ox2,oy2);

  const origPts3=toSVG(orig,ox3-sc,oy3);
  const angle=Math.PI/2;
  const rotOrig=orig.map(([x,y])=>[x*Math.cos(angle)-y*Math.sin(angle), x*Math.sin(angle)+y*Math.cos(angle)]);
  const rotPts=toSVG(rotOrig,ox3-sc,oy3);

  const k=1.8;
  const origPts4=toSVG(orig,ox4,oy4);
  const enlPts=toSVG(orig.map(([x,y])=>[x*k,y*k]),ox4,oy4);

  const Tri=({pts,fill,stroke})=>(
    <polygon points={pts.map(p=>p.join(",")).join(" ")} fill={fill} fillOpacity="0.5" stroke={stroke} strokeWidth="2"/>
  );

  return (
    <div style={S.dWrap}>
      <div style={S.dTitle}>Geometric Transformations — Translation, Reflection, Rotation, and Enlargement</div>
      <svg viewBox={`0 0 ${W} ${H}`} style={{width:'100%',display:'block'}}>
        {/* Translation */}
        <rect x={14} y={10} width={PW} height={H-20} rx={5} fill="#fff" stroke="#ccd9ea"/>
        <text x={14+PW/2} y={28} textAnchor="middle" fontSize="15" fill="#1F3864" fontWeight="700">Translation</text>
        <line x1={20} y1={oy1} x2={14+PW-8} y2={oy1} stroke="#eee" strokeWidth="1"/>
        <line x1={ox1} y1={50} x2={ox1} y2={oy1+40} stroke="#eee" strokeWidth="1"/>
        <Tri pts={origPts1} fill="#d0e8ff" stroke="#2E75B6"/>
        <Tri pts={transPts} fill="#fde8e8" stroke="#c0392b"/>
        <text x={origPts1[0][0]-8} y={origPts1[0][1]+14} fontSize="11" fill="#2E75B6" fontWeight="700">A</text>
        <text x={transPts[0][0]+4} y={transPts[0][1]+14} fontSize="11" fill="#c0392b" fontWeight="700">A'</text>
        <line x1={origPts1[2][0]} y1={origPts1[2][1]} x2={transPts[2][0]-4} y2={transPts[2][1]+2} stroke="#e07b00" strokeWidth="1.5" strokeDasharray="4,2"/>
        <polygon points={`${transPts[2][0]-4},${transPts[2][1]+2} ${transPts[2][0]-12},${transPts[2][1]+4} ${transPts[2][0]-8},${transPts[2][1]-4}`} fill="#e07b00"/>
        <rect x={20} y={242} width={PW-12} height={52} rx={3} fill="#EBF3FB" stroke="#2E75B6" strokeWidth="1"/>
        <text x={26} y={258} fontSize="11" fill="#1F3864" fontWeight="700">Translation by (a,b):</text>
        <text x={26} y={274} fontSize="11" fill="#2E75B6" fontFamily="'Courier New',monospace">(x,y) → (x+a, y+b)</text>
        <text x={26} y={288} fontSize="10" fill="#555">Size &amp; shape preserved</text>

        {/* Reflection */}
        <rect x={14+PW+8} y={10} width={PW} height={H-20} rx={5} fill="#fff" stroke="#ccd9ea"/>
        <text x={14+PW+8+PW/2} y={28} textAnchor="middle" fontSize="15" fill="#1F3864" fontWeight="700">Reflection</text>
        <line x1={14+PW+14} y1={oy2} x2={14+PW+8+PW-8} y2={oy2} stroke="#eee" strokeWidth="1"/>
        <line x1={ox2} y1={50} x2={ox2} y2={oy2+40} stroke="#27ae60" strokeWidth="2" strokeDasharray="6,3"/>
        <text x={ox2+4} y={58} fontSize="11" fill="#27ae60" fontWeight="700">mirror</text>
        <Tri pts={origPts2} fill="#d0e8ff" stroke="#2E75B6"/>
        <Tri pts={reflPts} fill="#fde8e8" stroke="#c0392b"/>
        <rect x={14+PW+14} y={242} width={PW-12} height={52} rx={3} fill="#EBF3FB" stroke="#2E75B6" strokeWidth="1"/>
        <text x={14+PW+20} y={258} fontSize="11" fill="#1F3864" fontWeight="700">Reflection in y-axis:</text>
        <text x={14+PW+20} y={274} fontSize="11" fill="#2E75B6" fontFamily="'Courier New',monospace">(x,y) → (−x, y)</text>
        <text x={14+PW+20} y={288} fontSize="10" fill="#555">In x-axis: (x,y)→(x,−y)</text>

        {/* Rotation */}
        <rect x={14+2*(PW+8)} y={10} width={PW} height={H-20} rx={5} fill="#fff" stroke="#ccd9ea"/>
        <text x={14+2*(PW+8)+PW/2} y={28} textAnchor="middle" fontSize="15" fill="#1F3864" fontWeight="700">Rotation</text>
        <line x1={14+2*(PW+8)+8} y1={oy3} x2={14+2*(PW+8)+PW-8} y2={oy3} stroke="#eee" strokeWidth="1"/>
        <line x1={ox3-sc} y1={50} x2={ox3-sc} y2={oy3+40} stroke="#eee" strokeWidth="1"/>
        <path d={`M ${origPts3[0][0]+18},${origPts3[0][1]} A 18 18 0 0 0 ${origPts3[0][0]},${origPts3[0][1]-18}`} fill="none" stroke="#e07b00" strokeWidth="1.5"/>
        <text x={origPts3[0][0]+22} y={origPts3[0][1]-10} fontSize="11" fill="#e07b00" fontWeight="700">90°</text>
        <Tri pts={origPts3} fill="#d0e8ff" stroke="#2E75B6"/>
        <Tri pts={rotPts} fill="#fde8e8" stroke="#c0392b"/>
        <circle cx={origPts3[0][0]} cy={origPts3[0][1]} r={4} fill="#1F3864"/>
        <rect x={14+2*(PW+8)+6} y={242} width={PW-12} height={52} rx={3} fill="#EBF3FB" stroke="#2E75B6" strokeWidth="1"/>
        <text x={14+2*(PW+8)+12} y={258} fontSize="11" fill="#1F3864" fontWeight="700">Rotation by θ about origin:</text>
        <text x={14+2*(PW+8)+12} y={274} fontSize="11" fill="#2E75B6" fontFamily="'Courier New',monospace">x'=xcosθ−ysinθ</text>
        <text x={14+2*(PW+8)+12} y={288} fontSize="11" fill="#2E75B6" fontFamily="'Courier New',monospace">y'=xsinθ+ycosθ</text>

        {/* Enlargement */}
        <rect x={14+3*(PW+8)} y={10} width={PW} height={H-20} rx={5} fill="#fff" stroke="#ccd9ea"/>
        <text x={14+3*(PW+8)+PW/2} y={28} textAnchor="middle" fontSize="15" fill="#1F3864" fontWeight="700">Enlargement</text>
        <line x1={14+3*(PW+8)+8} y1={oy4} x2={14+3*(PW+8)+PW-8} y2={oy4} stroke="#eee" strokeWidth="1"/>
        <Tri pts={origPts4} fill="#d0e8ff" stroke="#2E75B6"/>
        <Tri pts={enlPts} fill="#fde8e8" stroke="#c0392b"/>
        {origPts4.map((pt,i)=>(
          <line key={i} x1={ox4} y1={oy4} x2={enlPts[i][0]} y2={enlPts[i][1]} stroke="#9b59b6" strokeWidth="1" strokeDasharray="4,3"/>
        ))}
        <circle cx={ox4} cy={oy4} r={4} fill="#9b59b6"/>
        <text x={ox4-14} y={oy4+14} fontSize="11" fill="#9b59b6" fontWeight="700">O</text>
        <rect x={14+3*(PW+8)+6} y={242} width={PW-12} height={52} rx={3} fill="#EBF3FB" stroke="#2E75B6" strokeWidth="1"/>
        <text x={14+3*(PW+8)+12} y={258} fontSize="11" fill="#1F3864" fontWeight="700">Scale factor k:</text>
        <text x={14+3*(PW+8)+12} y={274} fontSize="11" fill="#2E75B6" fontFamily="'Courier New',monospace">(x,y) → (kx, ky)</text>
        <text x={14+3*(PW+8)+12} y={288} fontSize="10" fill="#555">Area scales by k²</text>
      </svg>
      <div style={S.dCaption}>Translation, reflection, and rotation are isometries — they preserve distances and angles. Enlargement changes size but preserves shape. All four can be expressed as matrix operations in homogeneous coordinates.</div>
    </div>
  );
}

function DiagramLocus() {
  const W=900, H=290;
  const cards=[
    {x:14,  w:168, color:"#2E75B6", fill:"#d0e8ff", title:"Fixed Distance\nfrom Point",    condition:"dist from (a,b) = r", eq:"(x−a)²+(y−b)²=r²", result:"Circle"},
    {x:190, w:168, color:"#27ae60", fill:"#d0f0d8", title:"Equidistant\nfrom 2 Points",   condition:"PA = PB",               eq:"perp. bisector",   result:"Straight Line"},
    {x:366, w:168, color:"#e07b00", fill:"#fff0cc", title:"Fixed Dist\nfrom a Line",      condition:"dist to line = k",      eq:"y = k  or  y = −k",result:"Parallel Lines"},
    {x:542, w:168, color:"#c0392b", fill:"#fde8e8", title:"PA + PB\n= constant",          condition:"sum of dists to foci",  eq:"x²/a²+y²/b²=1",   result:"Ellipse"},
    {x:718, w:168, color:"#9b59b6", fill:"#f5d0ff", title:"|PA − PB|\n= constant",        condition:"diff of dists to foci", eq:"x²/a²−y²/b²=1",   result:"Hyperbola"},
  ];
  return (
    <div style={S.dWrap}>
      <div style={S.dTitle}>Locus of Points — Common Loci and Their Equations</div>
      <svg viewBox={`0 0 ${W} ${H}`} style={{width:'100%',display:'block'}}>
        <rect x={14} y={10} width={W-28} height={44} rx={5} fill="#1F3864"/>
        <text x={W/2} y={30} textAnchor="middle" fontSize="15" fill="#fff" fontWeight="700">A locus is the set of all points satisfying a given geometric condition</text>
        <text x={W/2} y={48} textAnchor="middle" fontSize="12" fill="#aac8e8">Method: let P=(x,y), write condition algebraically, simplify to standard form</text>
        {cards.map(({x,w,color,fill,title,condition,eq,result})=>{
          const lines=title.split("\n");
          return (
            <g key={result}>
              <rect x={x} y={62} width={w} height={218} rx={5} fill={fill} stroke={color} strokeWidth="1.5"/>
              <rect x={x+4} y={66} width={w-8} height={38} rx={3} fill={color}/>
              <text x={x+w/2} y={82} textAnchor="middle" fontSize="11" fill="#fff" fontWeight="700">{lines[0]}</text>
              <text x={x+w/2} y={96} textAnchor="middle" fontSize="11" fill="#fff" fontWeight="700">{lines[1]}</text>
              <text x={x+10} y={120} fontSize="10" fill="#555" fontWeight="700">Condition:</text>
              <text x={x+10} y={134} fontSize="10" fill="#333">{condition}</text>
              <text x={x+10} y={156} fontSize="10" fill="#555" fontWeight="700">Equation:</text>
              <text x={x+10} y={172} fontSize="11" fill={color} fontFamily="'Courier New',monospace" fontWeight="700">{eq}</text>
              <rect x={x+6} y={188} width={w-12} height={40} rx={3} fill="#fff" fillOpacity="0.7"/>
              <text x={x+w/2} y={204} textAnchor="middle" fontSize="10" fill="#555">Locus is:</text>
              <text x={x+w/2} y={220} textAnchor="middle" fontSize="12" fill={color} fontWeight="700">{result}</text>
              {color==="#2E75B6" && <circle cx={x+w/2} cy={252} r={18} fill="none" stroke={color} strokeWidth="1.5"/>}
              {color==="#27ae60" && <line x1={x+w/2-22} y1={252} x2={x+w/2+22} y2={252} stroke={color} strokeWidth="2"/>}
              {color==="#e07b00" && <><line x1={x+w/2-22} y1={247} x2={x+w/2+22} y2={247} stroke={color} strokeWidth="1.5"/><line x1={x+w/2-22} y1={257} x2={x+w/2+22} y2={257} stroke={color} strokeWidth="1.5"/></>}
              {color==="#c0392b" && <ellipse cx={x+w/2} cy={252} rx={24} ry={14} fill="none" stroke={color} strokeWidth="1.5"/>}
              {color==="#9b59b6" && <><polyline points={`${x+w/2-22},${238} ${x+w/2-4},${252} ${x+w/2-22},${266}`} fill="none" stroke={color} strokeWidth="1.5"/><polyline points={`${x+w/2+22},${238} ${x+w/2+4},${252} ${x+w/2+22},${266}`} fill="none" stroke={color} strokeWidth="1.5"/></>}
            </g>
          );
        })}
      </svg>
      <div style={S.dCaption}>A locus question gives a geometric condition and asks for the equation of the path. Most standard loci reduce to the conics already studied: fix a distance from a point → circle; fix the sum of two distances → ellipse; fix the difference → hyperbola.</div>
    </div>
  );
}

export default function CoordGeometry() {
  return (
    <div style={S.wrapper}>
      <h1 style={S.h1}>Coordinate Geometry</h1>
      <p style={S.p}>Coordinate geometry bridges algebra and geometry by placing figures on a numbered grid. Every shape becomes an equation, every geometric property a calculation. This approach underpins computer graphics, engineering design, navigation, and virtually every applied science.</p>

      <InfoBox title="Core Idea: Every geometric object is an equation in x and y" items={[
        "Point: ordered pair (x, y) — position in the Cartesian plane",
        "Line: linear equation ax + by = c — slope encodes direction",
        "Circle: (x−h)²+(y−k)²=r² — all points at distance r from centre",
        "Conics: parabola, ellipse, hyperbola — all degree-2 curves, all slices of a cone",
        "Distance between (x₁,y₁) and (x₂,y₂) = √((Δx)²+(Δy)²) — Pythagorean theorem",
      ]}/>

      <h2 style={S.h2}>The Cartesian Plane</h2>
      <DiagramCartesian/>
      <Table2 rows={[
        ["Distance formula","d = √((x₂−x₁)² + (y₂−y₁)²)\nDerived from Pythagoras; always non-negative"],
        ["Midpoint formula","M = ((x₁+x₂)/2, (y₁+y₂)/2)\nAverage of each coordinate pair"],
        ["Section formula (m:n)","P = ((mx₂+nx₁)/(m+n), (my₂+ny₁)/(m+n))\nInternal division; flip signs for external division"],
        ["Gradient (slope)","m = (y₂−y₁)/(x₂−x₁) = tan θ\nθ is angle with positive x-axis"],
        ["Quadrants","I (+,+), II (−,+), III (−,−), IV (+,−)\nCounterclockwise from top-right"],
        ["Area of triangle","A = ½|x₁(y₂−y₃)+x₂(y₃−y₁)+x₃(y₁−y₂)|\nShoelace formula — works for any triangle given coordinates"],
      ]}/>

      <h2 style={S.h2}>Straight Lines</h2>
      <DiagramLines/>
      <Table2 rows={[
        ["Slope-intercept","y = mx + c\nm = slope, c = y-intercept"],
        ["Point-slope form","y − y₁ = m(x − x₁)\nUseful when slope and one point are known"],
        ["Two-point form","(y−y₁)/(y₂−y₁) = (x−x₁)/(x₂−x₁)\nSimplifies to slope-intercept form"],
        ["Intercept form","x/a + y/b = 1\na = x-intercept, b = y-intercept"],
        ["General form","ax + by + c = 0\n(a,b) is the normal vector to the line"],
        ["Perpendicular distance","d = |ax₀+by₀+c| / √(a²+b²)\nShortest distance from (x₀,y₀) to line ax+by+c=0"],
        ["Parallel lines","m₁ = m₂ (same slope, different intercept)"],
        ["Perpendicular lines","m₁ × m₂ = −1  (negative reciprocals)\nSpecial: vertical (undefined m) ⊥ horizontal (m=0)"],
        ["Angle between lines","tan θ = |(m₁−m₂)/(1+m₁m₂)|\nGives the acute angle between the two lines"],
      ]}/>

      <h2 style={S.h2}>The Circle</h2>
      <DiagramCircle/>
      <Table2 rows={[
        ["Standard form","(x−h)²+(y−k)²=r²\nCentre (h,k), radius r"],
        ["General form","x²+y²+2gx+2fy+c=0\nCentre (−g,−f), radius = √(g²+f²−c)"],
        ["Tangent at point (x₁,y₁)","xx₁+yy₁=r² (circle centred at origin)\nPerpendicular to radius at that point"],
        ["Tangent from external point","Length = √(d²−r²)\nd = distance from external point to centre"],
        ["Line meets circle","Substitute line into circle; check discriminant\nΔ>0: 2 pts, Δ=0: tangent, Δ<0: no intersection"],
        ["Chord midpoint","CM ⊥ chord where C is centre, M is midpoint\nPerpendicular from centre bisects every chord"],
        ["Arc & sector","Arc = rθ,  Sector area = ½r²θ  (θ in radians)\nCircumference = 2πr,  Area = πr²"],
      ]}/>

      <h2 style={S.h2}>Conic Sections</h2>
      <DiagramConics/>
      <Table2 rows={[
        ["Parabola (up/down)","(x−h)²=4p(y−k)\nVertex (h,k), focus at (h, k+p), directrix y=k−p"],
        ["Parabola (left/right)","(y−k)²=4p(x−h)\nOpens right if p>0, left if p<0"],
        ["Ellipse","x²/a²+y²/b²=1  (a>b>0)\nc²=a²−b², foci (±c,0), eccentricity e=c/a<1"],
        ["Hyperbola","x²/a²−y²/b²=1\nc²=a²+b², foci (±c,0), asymptotes y=±(b/a)x"],
        ["General conic","Ax²+Bxy+Cy²+Dx+Ey+F=0\nB²−4AC<0: ellipse, =0: parabola, >0: hyperbola"],
        ["Eccentricity","e=0: circle, 0<e<1: ellipse, e=1: parabola, e>1: hyperbola\ne = dist to focus ÷ dist to directrix"],
      ]}/>

      <h2 style={S.h2}>Geometric Transformations</h2>
      <DiagramTransformations/>
      <Table2 rows={[
        ["Translation by (a,b)","(x,y) → (x+a, y+b)\nPreserves size, shape, orientation"],
        ["Reflection in x-axis","(x,y) → (x, −y)"],
        ["Reflection in y-axis","(x,y) → (−x, y)"],
        ["Reflection in y=x","(x,y) → (y, x)"],
        ["Rotation 90° CCW","(x,y) → (−y, x)"],
        ["Rotation 180°","(x,y) → (−x, −y)"],
        ["Rotation by θ (general)","x'=x cosθ−y sinθ,  y'=x sinθ+y cosθ\nAbout origin; CCW positive"],
        ["Enlargement, factor k","(x,y) → (kx, ky) about origin\nArea scales by k²; k<0 reflects through origin"],
      ]}/>

      <h2 style={S.h2}>Locus of Points</h2>
      <DiagramLocus/>
      <Table2 rows={[
        ["Method","Let P=(x,y), write the geometric condition algebraically, simplify"],
        ["Equidistant from 2 points","Perpendicular bisector of the segment joining them"],
        ["Fixed distance from point","Circle: (x−a)²+(y−b)²=r²"],
        ["Fixed distance from line","Two parallel lines on either side of the given line"],
        ["PA+PB=const","Ellipse with foci at A and B"],
        ["|PA−PB|=const","Hyperbola with foci at A and B"],
        ["Angle bisector locus","Pair of lines — use the distance-to-line formula"],
      ]}/>

      <InfoBox title="Key Takeaway — Which Formula to Use and When" items={[
        "Distance between two points? → √((Δx)²+(Δy)²)",
        "Equation of line through two points? → Point-slope or two-point form",
        "Distance from point to line ax+by+c=0? → |ax₀+by₀+c| / √(a²+b²)",
        "Line perpendicular to slope m? → New slope = −1/m",
        "Circle from centre (h,k) and radius r? → (x−h)²+(y−k)²=r²",
        "Tangent from external point? → Length = √(d²−r²)",
        "Conic type from general equation? → Check discriminant B²−4AC",
        "Locus problem? → Let P=(x,y), write condition, simplify to standard form",
      ]}/>
    </div>
  );
}